import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconModified } from 'src/assets/icons/Modified';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { STRUCTURE_INSTRUCTIONS_LABEL } from 'src/data/ui';

import { useStyles } from './useStyles';

export const HeaderListItem = forwardRef(({ className, onSettingsClick, disabled }, ref) => {
  const styles = useStyles();

  return (
    <div
      className={cx(styles.root, className)}
      ref={ref}
    >
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        Improve
      </CustomTypography>

      <CustomTooltip title={STRUCTURE_INSTRUCTIONS_LABEL}>
        <CustomIconButton
          onClick={onSettingsClick}
          disabled={disabled}
        >
          <IconModified />
        </CustomIconButton>
      </CustomTooltip>
    </div>
  );
});

HeaderListItem.propTypes = {
  className: PropTypes.string,
  onSettingsClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
HeaderListItem.defaultProps = {
  className: '',
  disabled: false,
};
